import { Component, Input } from '@angular/core';
import { ChoiceInputComponent } from '../choice-input/choice-input.component';

@Component({
  selector: 'app-radio-list',
  templateUrl: './radio-list.component.html',
  styleUrls: ['./radio-list.component.scss'],
  standalone: false
})
export class RadioListComponent<T> extends ChoiceInputComponent<T> {

  @Input()
  public reverse = false;

  @Input()
  public horizontal = false;
}
